export const cartRequestItem = (item) => ({
  product_id: item.product_id,
  variant_label: item.product_type === "gift_box" ? null : item.variant_label || null,
  quantity: item.quantity,
  hamper_selections: item.hamper_selections || [],
});

export const inventoryParts = (item) => item.inventory_items || [{
  product_id: item.product_id,
  variant_label: item.variant_label || null,
  quantity: 1,
  available_stock: Number(item.available_stock) || 0,
}];

const inventoryKey = (item) => {
  if (item.source === "box") {
    return `box::${item.product_id}`;
  }
  if (item.custom_item_id) {
    return `custom::${item.product_id}::${item.custom_item_id}`;
  }
  return `catalogue::${item.product_id}::${item.variant_label || ""}`;
};

export const cartStockLimit = (item, cart) => Math.max(
  0,
  Math.min(...inventoryParts(item).map((part) => {
  const used = cart
    .filter((other) => other._k !== item._k)
    .reduce((total, other) => total + inventoryParts(other)
      .filter((entry) => inventoryKey(entry) === inventoryKey(part))
      .reduce((sum, entry) => sum + entry.quantity * other.quantity, 0), 0);
  return Math.floor((part.available_stock - used) / part.quantity);
  })),
);
